
import YoutubeEmbed from '../private/YoutubeEmbed'

export default {
  components: {
    YoutubeEmbed,
  },
  props: {
    youtubeId: {
      type: String,
      required: true,
    },
  },
}
